<script lang="ts">
    import translate from '../../../../../lib/translate'
    import { showStore as show, valuesStore as values } from '../../../stores'
    import label from './AuctionDetails.translation'
    
    const pulse = (node, { duration, iterations }) => {
        let iteration = 0
        let i = 1/iterations
        return {
            duration,
            css: t => {
                let s = t-iteration*i // reduce by iteration offset
                if(s > i) {
                    s = t-(++iteration)*i // if s reaches iteration-length, increase iteration and reset s
                }
                s *= iterations // scale back to 0-1 range
                return `
                    font-size: ${Math.round(17*(2-s))}px;
                    color: #B4146E;
                `
            }
        }
    }
</script>

{#if $show.meta && $values}
    <div class="auction-details">
        <p class="auction-detail">
            <span class="label">{translate(label.startPrice)}</span>
            <span class="value auction-detail-startprice">{$show.meta.startPrice.text}</span>
        </p>
        <p class="auction-detail">
            <span class="label">{translate(label.currentPrice)}</span>
            {#if $values.currentPrice.cent < $show.meta.startPrice.cent}
                {#key $values.currentPrice.text}
                    <span class="value auction-detail-price" in:pulse={{duration:1500, iterations: 3}}>{$values.currentPrice.text}</span>
                {/key}
            {:else}
                <span class="value auction-detail-price">{$values.currentPrice.text}</span>
            {/if}
        </p>
        <p class="auction-detail">
            <span class="label">{translate(label.quantity)}</span>
            {#key $values.quantity}
                <span class="value auction-detail-pieces" in:pulse={{duration:500, iterations: 1}}>{$values.quantity}</span>
            {/key}
        </p>
    </div>
{/if}